import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getTitleForLocation } from './useTitle.utils';

/**
 * Sets document title
 * If title is provided, we set it as the document title
 * Eg: Order page, Wardrobe page, Add Item page,
 * Usage: useTitle(GENIE_ADD_ITEM_PAGE_TITLE)
 *
 * If not, we derive the title based on the location
 * Eg: Dashboard, Profile, My Measurements
 * All pages except Product related pages which is handled by useProductTitle
 *
 * @param {String} title
 */
const useTitle = (title) => {
  const location = useLocation();

  useEffect(() => {
    const titleToUse = title || getTitleForLocation(location);
    document.title = titleToUse;
  });
};

export default useTitle;
